import {
  Popper,
  CircularProgress,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell
} from '@material-ui/core';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef
} from 'react';
import {
  TAiStandardItem,
  TUpdateEstimateItemList
} from '../../../types/estimate/estimate';
import { sub } from 'date-fns';
import { getAiEstimateStandard } from '../../../apicalls/getAiEstimate';
import { isLoggedIn } from '../../../GlobalState';
import { useSetRecoilState } from 'recoil';

const popupStyle = {
  padding: '10px',
  backgroundColor: 'white',
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)',
  borderRadius: '4px',
  maxWidth: '300px',
  margin: '5px'
};

const popupSpanStyle = (estimateItem: string) => {
  return {
    borderBottom: '1px solid ' + (estimateItem === '' ? '#758283' : 'black'),
    color: estimateItem === '' ? '#758283' : 'black'
  };
};

type AiItemProps = {
  estimateItem: string;
  updateEstimateItemList: TUpdateEstimateItemList;
  parentItemIndex: number;
  sub_index: number;
  handleError: (message: string) => void;
};

export const AiItemPopup: React.FC<AiItemProps> = (props: AiItemProps) => {
  const {
    estimateItem,
    updateEstimateItemList,
    parentItemIndex,
    sub_index,
    handleError
  } = props;
  const [itemAnchorEl, setItemAnchorEl] = useState<null | HTMLElement>(null);
  const showAiItemPopup = Boolean(itemAnchorEl);
  const popperRef = useRef<HTMLDivElement>(null);

  const setLoggedIn = useSetRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [isAiStandardItemLoading, setIsAiStandardItemLoading] =
    useState<boolean>(false);

  const [standardItemList, setStandardItemList] = useState<TAiStandardItem>({
    category: '',
    sub_items: []
  });

  const handleAiItemClick = (event: React.MouseEvent<HTMLElement>) => {
    setItemAnchorEl(itemAnchorEl ? null : event.currentTarget);
  };
  const popperButtonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // ポップアップ外のクリックを検出するイベントハンドラ
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target as Node)
      ) {
        setItemAnchorEl(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popperRef]);

  const getListOfAiEstimateStandard = (estimateItemName: string) => {
    setIsAiStandardItemLoading(true);
    const standardItem = sessionStorage.getItem(estimateItemName);
    if (standardItem) {
      setStandardItemList(JSON.parse(standardItem));
      setIsAiStandardItemLoading(false);
    } else {
      getAiEstimateStandard(estimateItemName).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            handleError(data);
          } else {
            if (data.error) {
              handleError(data.error);
            } else {
              setIsAiStandardItemLoading(false);
              setStandardItemList(data);
              sessionStorage.setItem(estimateItemName, JSON.stringify(data));
            }
          }
        }
      });
    }
  };

  return (
    <div ref={popperButtonRef}>
      <div style={{ textAlign: 'right', paddingRight: '20px' }}>
        <span
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            if (estimateItem !== '') {
              handleAiItemClick(event);
              getListOfAiEstimateStandard(estimateItem);
            }
          }}
          style={popupSpanStyle(estimateItem)}
        >
          定番小項目を選択
        </span>
      </div>
      <Popper open={showAiItemPopup} anchorEl={itemAnchorEl} ref={popperRef}>
        {isAiStandardItemLoading ? (
          <div style={popupStyle}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <CircularProgress />
            </div>
          </div>
        ) : standardItemList.sub_items.length === 0 ? (
          <div style={popupStyle}>参照するデータがありません。</div>
        ) : (
          <div style={popupStyle}>
            <p
              style={{ fontWeight: 400 }}
            >{`カテゴリ"${standardItemList.category}"の定番小項目`}</p>
            <TableContainer style={{ maxHeight: '200px' }}>
              <Table aria-label='sticky table'>
                <TableBody>
                  {standardItemList.sub_items.map((subItem, index) => (
                    <TableRow
                      hover
                      key={index}
                      onClick={() => {
                        updateEstimateItemList(
                          { key: 'name', value: String(subItem) },
                          [parentItemIndex, sub_index]
                        );
                        setItemAnchorEl(null);
                      }}
                    >
                      <TableCell>{subItem}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Popper>
    </div>
  );
};
